import { useStaticQuery, graphql } from 'gatsby'

const useFluidImage = fileName => {
  const data = useStaticQuery(graphql`
    query {
      images: allFile {
        edges {
          node {
            relativePath
            name
            childImageSharp {
              fluid(maxWidth: 1920) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
        }
      }
    }
  `)

  const image = data.images.edges.find(n =>
    n.node.relativePath.includes(fileName)
  )

  return image && image.node.childImageSharp.fluid
}

export default useFluidImage
